module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.6633/images/default-avatar.png"